import React, { useState } from "react";

/**
 * Iter-297 — "Continue with Google" using the founder's own Google OAuth
 * client mounted on the shared backend. The consent screen shows
 * "AllSale" (not Emergent). Flow:
 *
 *   1. Click → window.location.assign("/api/auth/google/start?next=…")
 *   2. Backend handles consent + CSRF and eventually redirects back to
 *      /auth/google/done#gt=<jwt>&next=<path> (see GoogleDonePage.jsx).
 *
 * The old Emergent session-id relay is still redeemed by
 * GoogleSessionRedeemer as a one-release fallback but is NO LONGER the
 * button's target.
 */
export default function GoogleSignInButton({ disabled = false, className = "", label = "Continue with Google", nextPath = "/" }) {
  const [pending, setPending] = useState(false);
  const onClick = () => {
    setPending(true);
    const target = "/api/auth/google/start?next=" + encodeURIComponent(nextPath || "/");
    window.location.assign(target);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || pending}
      data-testid="google-signin-btn"
      className={
        "w-full inline-flex items-center justify-center gap-2 rounded-full bg-white border border-slate-300 hover:border-slate-400 hover:bg-slate-50 text-slate-800 font-semibold py-3 transition-colors disabled:opacity-60 " +
        className
      }
    >
      <GoogleGlyph />
      <span>{pending ? "Opening Google…" : label}</span>
    </button>
  );
}

/** Official 4-colour Google "G" glyph — flat SVG, no external asset. */
function GoogleGlyph({ size = 18 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
      <path fill="none" d="M0 0h48v48H0z" />
    </svg>
  );
}
